<div #outsideModal class="modal">
    <div #modalBody class="modal-content" [ngClass]="{ 'bluring': isPending }">
      <div class="modal-header">Connexion MSS</div>
      <div class="modal-body">
  
        <!-- Sélectionner un compte MSS -->
        <ng-container *ngIf="currentState === currentStateTemplate.selectAccount">
            <form [formGroup]="accountForm" *ngIf="accountForm && accounts && accounts.length > 0">
              <frg-form-input label="Sélectionnez un compte" [formGroup]="accountForm" type="ngSelect"
                [selectValue]="accounts" id="account" [control]="accountForm.get('account')" required="true"
                errorMessage="Veuillez sélectionner un compte" [isClearableSelect]="false"></frg-form-input>
              <div class="buttons-wrapper center">
                <frg-button type="button" (activated)="selectAccount(false)" [disabled]="!accountForm.valid || !isMSSSet"
                  fullWidth="true">Valider</frg-button>
              </div>
            </form>
        </ng-container>
  
      </div>
    </div>
  </div>
  <div class="modal-background"></div>